import React from 'react'
import FormGroup from '@mui/material/FormGroup';
import { styled } from '@mui/material/styles';
import Square from '@mui/icons-material/Square';
import CheckBoxMat from '@mui/icons-material/CheckBox';
import { Typography, Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import close from './../../../../../img/close-button-icon.png';
import open from './../../../../../img/close-button-icon-color.png';
import { WindowSharp } from '@mui/icons-material';


const FormGroupColor = styled(FormGroup)(({ theme }) => ({

  // Some CSS
  overflowY: "auto",
  flexDirection: "row",
  margin: 0,
  padding: 0,
  listStyle: "none",
  height: "100%",
  scrollbarWidth: "thin",
  '&::-webkit-scrollbar': {
    width: '0.2em'
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)',
    outline: '1px solid rgb(0 0 0 / 54%)'
  }
  ,
}));


function IconCheckboxes(props) {
  const [checked, setChecked] = React.useState(props.checked);

  const handleClick = (event) => {

    let code = props.code;
    let value = event.target.id;
    if (checked.hasOwnProperty(code)) {

      let currentIndex = checked[code].indexOf(value);
      if (currentIndex === -1) {
        checked[code].push(String(value));
      } else {
        checked[code].splice(currentIndex, 1);
      }


    }
    else {
      if (code != "")
        checked[code] = [String(value)];
    }


    setChecked(checked);
    props.setCheckenFiltr(checked);
    props.submitForm();
  };

  return (
    <>
      <Checkbox sx={{ p: 0, color: props.color }} id={props.nameValeu} data-name={props.code}
        onChange={handleClick}
        icon={<Square />} checked={checked[props.code] ? checked[props.code].indexOf(props.nameValeu) !== -1 : false} checkedIcon={<CheckBoxMat sx={{ color: props.color, }}

        />} />
    </>
  );
}

function DisplayTypeCompanentG(props) {

  const [checked, setChecked] = React.useState(props.checked);
  let colorArray = props.propertyValue.HighloadBlockValue;
  const [valueagNameImage, setTagNameImage] = React.useState(false);

  const MouseOver = (e) => {

    setTagNameImage(true);
  }
  const MouseOut = (e) => {
    setTagNameImage(false);
  }
  const RemoveChecks = () => {
    checked[props.code] = [];
    setChecked(checked);
    props.setCheckenFiltr(checked);
    props.submitForm();
  }

  return (
    <>
      <Typography sx={{ mt: 1, mb: 1, fontWeight: 600, display: "flex", justifyContent: "space-between" }} variant="h6" component="div">
        <div>{props.name}</div>
        {checked[props.code]?.length >= 1 && (
          <Button variant="text" size="small" onClick={RemoveChecks}>Очистить</Button>
        )}
      </Typography>
      <FormGroupColor
        sx={{ width: '100%', maxWidth: 290, maxHeight: 240, bgcolor: 'background.paper', overflow: 'auto', height: 'auto' }}

      >
        <>
          {props.propertyValue.HighloadBlockValue != undefined ?
            props.propertyValue.HighloadBlockValue.reverse().sort()
              .map((value, i) => {


                return (
                  <IconCheckboxes key={i} color={value} id={value.ID} code={props.code} countfiltr={value.countfiltr} nameValeu={value.slice(1)} checked={props.checked} submitForm={props.submitForm} setCheckenFiltr={props.setCheckenFiltr} />
                );
              })
            : <div>По вашему запросу не чего не найдено</div>
          }
        </>
      </FormGroupColor>
    </>
  )
}

export default DisplayTypeCompanentG;
